<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Agent Detail</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <h3 class="detail__name">{{ agent.name }}</h3>

      <dl class="detail">
        <div class="detail__row">
          <dt>Email</dt>
          <dd>{{ agent.email }}</dd>
        </div>
        <div class="detail__row">
          <dt>Phone</dt>
          <dd>{{ agent.number }}</dd>
        </div>
        <div class="detail__row">
          <dt>Max limit</dt>
          <dd>{{ agent.limit }}</dd>
        </div>
        <div class="detail__row">
          <dt>Total sales</dt>
          <dd>
            <strong>{{ soldCards.length }}</strong>
          </dd>
        </div>
      </dl>

      <div class="sold">
        <span v-for="card in soldCards" :key="card.number" class="sold__item">
          <strong>{{ card.number }}</strong>
          {{ card.name }}
        </span>
      </div>
      <p v-if="!soldCards.length" class="tb-empty">No tickets sold in this game.</p>
    </section>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "AgentInfo",
    props: {
      agent: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(["cards"]),
      soldCards() {
        return this.cards.filter((card) => card.agent === this.agent.email);
      }
    }
  };
</script>

<style scoped>
  .detail__name {
    margin: 0 0 14px;
    font-size: clamp(18px, 5vw, 24px);
    text-align: left;
  }

  .detail {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 0 0 18px;
  }

  .detail__row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 6px;
    border-bottom: 1px solid var(--tb-line);
    font-size: 14px;
  }

  .detail__row dt {
    color: var(--tb-ink-soft);
    font-weight: 400;
  }

  .detail__row dd {
    margin: 0;
    min-width: 0;
    overflow-wrap: anywhere;
    text-align: right;
  }

  .sold {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 6px;
  }

  .sold__item {
    padding: 8px 10px;
    border-radius: 8px;
    background: var(--tb-surface-alt);
    font-size: 13px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
